import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propBool, propChildren } from '../../../helpers/custom-prop-types';
const ShowModal = ({ children, isShow }) => (_jsx("div", Object.assign({ className: `modal ${isShow ? 'is-active' : ''}` }, { children: _jsx("div", Object.assign({ className: 'modal-container' }, { children: _jsx("div", Object.assign({ className: 'modal-inner' }, { children: children })) })) })));
ShowModal.propTypes = {
    children: propChildren().isRequired,
    isShow: propBool().isRequired,
};
export default ShowModal;
